import { Section, NextBar, In } from "./Fields";

export default function LandlordStep({
  landlords, landlordId, setLandlordId,
  landlordForm, setLandlordForm,
  propertyForm, setPropertyForm,
  onNext,
}) {
  return (
    <Section title="Landlord or letting agent" subtitle="Select an existing landlord or create a new one.">
      <div className="grid md:grid-cols-2 gap-3 mb-6">
        {landlords.map((l) => (
          <button
            key={l.id}
            onClick={() => {
              setLandlordId(l.id);
              setPropertyForm({ ...propertyForm, landlord_id: l.id });
            }}
            data-testid={`wizard-pick-landlord-${l.id}`}
            className={`text-left p-4 border rounded-md transition-colors ${
              landlordId === l.id ? "border-[#1E3A5F] bg-[#1E3A5F] text-white" : "border-[#E5E7EB] bg-white hover:border-[#1E3A5F]/40"
            }`}
          >
            <div className="font-semibold">{l.name}</div>
            <div className={`text-xs mt-0.5 ${landlordId === l.id ? "text-white/70" : "text-[#6B7280]"}`}>
              {l.company_name || "—"} · {l.email || l.phone || "—"}
            </div>
          </button>
        ))}
      </div>

      {!landlordId && (
        <div className="trent-card p-5 bg-[#FAFAF7]">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#6B7280] mb-3">Or add new</div>
          <div className="grid md:grid-cols-2 gap-3">
            <In label="Name *" v={landlordForm.name} on={(v) => setLandlordForm({ ...landlordForm, name: v })} test="wizard-landlord-name" />
            <In label="Company" v={landlordForm.company_name} on={(v) => setLandlordForm({ ...landlordForm, company_name: v })} />
            <In label="Phone" v={landlordForm.phone} on={(v) => setLandlordForm({ ...landlordForm, phone: v })} />
            <In label="Email" v={landlordForm.email} on={(v) => setLandlordForm({ ...landlordForm, email: v })} />
            <In label="Address" v={landlordForm.address} on={(v) => setLandlordForm({ ...landlordForm, address: v })} full />
            <In label="Notes" v={landlordForm.notes} on={(v) => setLandlordForm({ ...landlordForm, notes: v })} full textarea />
          </div>
        </div>
      )}

      <NextBar onNext={onNext} testId="wizard-next-1" />
    </Section>
  );
}
